import { render, staticRenderFns } from "./OrderVehicleSelect.vue?vue&type=template&id=e0f470c8"
import script from "./OrderVehicleSelect.vue?vue&type=script&lang=js"
export * from "./OrderVehicleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports